import React, { useEffect, useState, ReactElement } from "react";

import Youtube from "./sources/youtube";
import Vimeo from "./sources/vimeo";
import HespStream from "./sources/hesp";
import Webrtc from "./sources/webrtc";
import CloudStorageVideo from "./sources/cloudStorageVideo";

function getComponent(type: string): ReactElement {
  switch (type) {
    case "hesp":
      return HespStream;
    case "youtube":
      return Youtube;
    case "vimeo":
      return Vimeo;
    case "webrtc":
      return Webrtc;
    case "cloudStorage":
      return CloudStorageVideo;
    default:
      return NoPlayer;
  }
}

export default function streamPlayerComponent({
  streamDetail,
}: {
  streamDetail: any;
  stream_id: string;
}): ReactElement {
  const [_streamDetail, setStreamDetail] = useState({ type: "" });

  useEffect(() => {
    if (!streamDetail) {
      setStreamDetail(null);
      return;
    }

    setStreamDetail(streamDetail);
  }, [streamDetail]);

  const PlayerComponent = getComponent(_streamDetail?.type);

  return <PlayerComponent {..._streamDetail} />;
}

const NoPlayer = () => {
  return <></>;
};
